import patchStateReducer from '@coxy/utils/src/redux/patch-state'
import { createSlice, type PayloadAction } from '@reduxjs/toolkit'
import { EnvName } from './models'

export const storeKey = '@redux/env'

export type EnvState = {
  current: EnvName
}

const initialState: EnvState = {
  current: EnvName.production,
}

export const whitelist = ['current']

export const envSlice = createSlice({
  name: storeKey,
  initialState,
  reducers: {
    setEnv(state, action: PayloadAction<EnvName>) {
      state.current = action.payload
    },
    patchEnvState: (state, action: PayloadAction<Partial<EnvState>>) => patchStateReducer(state, action),
  },
})

export const { setEnv, patchEnvState } = envSlice.actions
